export const calculateVisibleNavItems = ({
  itemWidths,
  availableWidth,
  moreWidth,
  maxVisible,
  gap,
}) => {
  const widths = Array.isArray(itemWidths) ? itemWidths.slice(0, maxVisible) : [];
  if (!widths.length || availableWidth <= 0) return 0;

  for (let count = widths.length; count >= 0; count -= 1) {
    const hasOverflow = count < itemWidths.length;
    const visibleWidth = widths.slice(0, count).reduce((total, width) => total + width, 0);
    const visibleGaps = Math.max(0, count - 1) * gap;
    const overflowWidth = hasOverflow ? moreWidth + (count > 0 ? gap : 0) : 0;

    if (visibleWidth + visibleGaps + overflowWidth <= availableWidth) return count;
  }

  return 0;
};
